export const LOGO_TYPES = {
	WFW_EN: "wfw-en",
	WFW_ES: "wfw-es",
	WS: "ws",
	YDR: "ydr",
};
